<template>
  <div class="tablediv box">
    <div class="box_f1 box box_v">
      <dv-decoration-7>　{{title}}　</dv-decoration-7>
      <div class="box_f1">
        <dv-border-box-8>
          <dv-scroll-board :config="config" />
        </dv-border-box-8>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'csscAllTable',
    computed: {
      xiaofeiquanVue() {
        return this.$store.state.xiaofeiquanVue
      },
    },
    created() {
      this.config = this.getConfig([['', '', '', '']])
      //4大类总消费金额排名
      //04--超市，05--商场,06--家电，07--金银珠宝,
      let resobj = {
        '04':{"isSucceed":true,"message":"","rows":[{"companyName":"河北美食林商贸集团有限公司滏东购物广场(美食林滏东购物广场)","goodsAmount":649862.88,"consumeNum":7287},{"companyName":"河北美食林商贸集团有限公司新城购物广场-超市","goodsAmount":555202.71,"consumeNum":6178},{"companyName":"河北美食林商贸集团有限公司新宇购物广场(美食林新宇购物广场)","goodsAmount":499648.59,"consumeNum":5501},{"companyName":"天鸿店-阳光超市","goodsAmount":438340.59,"consumeNum":5041},{"companyName":"邯郸市阳光超市有限公司前进店（前进店)","goodsAmount":381526.86,"consumeNum":3993},{"companyName":"","goodsAmount":350421.62,"consumeNum":3922},{"companyName":"河北美食林商贸集团有限公司千百家分公司","goodsAmount":281300.97,"consumeNum":3139},{"companyName":"河北美食林商贸集团有限公司邯郸鑫港分公司(美食林鑫港购物广场)","goodsAmount":270515.01,"consumeNum":2855},{"companyName":"河北美食林商贸集团有限公司新春分公司","goodsAmount":267933.89,"consumeNum":3042},{"companyName":"河北美食林商贸集团有限公司滏春分公司(美好之家)","goodsAmount":262570.38,"consumeNum":2912}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '07':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸阳光新世纪股份有限公司-金银珠宝","goodsAmount":987711.56,"consumeNum":243},{"companyName":"邯郸市赵都黄金珠宝有限公司","goodsAmount":568775.40,"consumeNum":136},{"companyName":"邯郸万达工贸有限公司—金银珠宝","goodsAmount":376318.00,"consumeNum":114},{"companyName":"邯郸市阳光新龙商贸有限公司天鸿广场分公司-金银珠宝","goodsAmount":26623.00,"consumeNum":5}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '06':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸市阳光三联电器有限公司-家电","goodsAmount":14753051.30,"consumeNum":9658},{"companyName":"邯郸苏宁易购商贸有限公司丛台稽山新天地店","goodsAmount":2238199.20,"consumeNum":1751},{"companyName":"邯郸苏宁易购商贸有限公司","goodsAmount":2111157.40,"consumeNum":1544},{"companyName":"邯郸苏宁易购商贸有限公司丛台区美乐城店","goodsAmount":1230208.30,"consumeNum":974},{"companyName":"","goodsAmount":627919.00,"consumeNum":374},{"companyName":"邯郸市康德超级市场有限公司—家电","goodsAmount":199755.00,"consumeNum":195}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '05':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸阳光新世纪股份有限公司-百货餐饮","goodsAmount":8233541.19,"consumeNum":23256},{"companyName":"邯郸万达工贸有限公司—百货餐饮","goodsAmount":5876133.20,"consumeNum":40184},{"companyName":"邯郸市阳光新龙商贸有限公司天鸿广场分公司-百货餐饮","goodsAmount":2693851.90,"consumeNum":14257},{"companyName":"邯郸市丛台区国风购物中心","goodsAmount":1440998.00,"consumeNum":12289},{"companyName":"邯郸市阳光三联电器有限公司-百货餐饮","goodsAmount":694229.80,"consumeNum":4954},{"companyName":"邯郸市阳光超市有限公司人民路分公司-百货.餐饮","goodsAmount":491531.70,"consumeNum":3505},{"companyName":"邯郸市康德超级市场有限公司—百货餐饮","goodsAmount":437621.00,"consumeNum":3421},{"companyName":"邯郸市美乐百货管理有限公司(美乐百货)","goodsAmount":282700.50,"consumeNum":1939},{"companyName":"","goodsAmount":259425.40,"consumeNum":2271},{"companyName":"新丹兰尚街","goodsAmount":60374.50,"consumeNum":418}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
      }

      // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/top',{
      //   discountCouponTypeNO: this.type
      // },res=> {
        let res = resobj[this.type]
        let data = res.rows.map(item=> {
          return ['<span title="'+item.companyName+'">'+item.companyName+'</span>',
            '<span title="'+item.goodsAmount+'">'+this.toThousands(item.goodsAmount, true)+'</span>',
            '<span title="'+item.consumeNum+'">'+this.toThousands(item.consumeNum, true)+'</span>']
        })
        this.config = this.getConfig(data)
      // })
    },
    methods: {
      getConfig(data) {
        if(data.length<1) {
          data = [['', '', '', '']]
        }
        return {
          header: ['企业名称', '消费总金额(元)', '核销总数(张)'],
          data: data,
          index: true,
          waitTime: 3000,
          headerBGC: 'rgba(29, 193, 245,.5)',
          oddRowBGC: '',
          evenRowBGC: '',
          columnWidth: [50, 230],
          align: ['center', 'left', 'center','center']
        }
      },
      toThousands(_num, bol) {
        _num = _num.toFixed(4)*1
        let numArr = (_num+'').split('.')
        let num = parseInt(numArr[0])
        let xs = numArr[1]?numArr[1]:''

        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(xs) {
          result = [...result, '.', ...xs.split('')]
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      },
      _toThousands(num, bol) {
        num = parseInt(num)
        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      }
    },
    data () {
      return {
        config: {}
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less">
  .tablediv {
    position: relative;
    width: 100%;
    height: 50%;

    .dv-scroll-board {
      height: 100%;
    }
    .dv-border-box-8 {
      .border-box-content {
        padding: 10px!important;
      }
    }
    .dv-decoration-7 {
      height: 25px;
      margin: 20px 0px!important;
      font-size: 16px;
    }
  }
</style>
